import {html} from "@isceco/widget-library2/external/lit";

export default class StyledCell {

  get name() {
    return 'Styled' + this.cell.name
  }

  constructor(cell, style) {
    this.cell = cell
    this.style = style
  }

  render(i18n, cell, row) {
    return html`
      <div style="${this.style ? this.style(row) : ''}">
        ${this.cell.render(i18n, cell, row)}
      </div>
    `
  }
}
